// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__V5w0a","content":"styles_content__2j9mu","row":"styles_row__1a4nf","footer":"styles_footer__jzi7D","phraseLength":"styles_phraseLength__2qOKK"};